import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { EvaluationService } from 'src/app/shared/services/evaluationservice/evaluation.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-evaluation-summary',
  templateUrl: './evaluation-summary.component.html',
  styleUrls: ['./evaluation-summary.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule]
})
export class EvaluationSummaryComponent implements OnInit {
  public showSpinner = true;
  public evaluations: any = [];
  public KPValues: any = [];
  public check = true;
  public evaluation_later: any = [];
  public user: any = [];
  public lateCheckIn: any;
  public dailyScrum: any;
  public absent: any;
  public asana: any;
  public taskDelivered: any;
  evaluation: any;
  evaluationPoints: any;
  totalRating: any;
  band1 = false;
  band2 = false;
  band3 = false;
  band4 = false;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  P_M_evaluationPoints: any;
  totalRating1: any;
  data: { evaluation: any; KPValues: any; };
  user_role: any;
  roleType: any;
  currentUrl: any;


  constructor(
    public route: ActivatedRoute,
    private router: Router,
    public evaluationService: EvaluationService,
    public evalService: EvaluationService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
  ) {
    this.getCurrentUrl();
    this.getEvaluation();
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_role = JSON.parse(this.user.user_role.user_roles)
    this.roleType = this.user_role?.role_type;
    this.data = {
      evaluation: JSON.parse(this.route.snapshot.queryParams.data),
      KPValues: JSON.parse(this.route.snapshot.queryParams.kpValues)
    }
    this.evaluation = JSON.parse(this.route.snapshot.queryParams.data);
    this.KPValues = JSON.parse(this.route.snapshot.queryParams.kpValues);
    // this.evaluationPoints = this.evaluation.kps_value.split(',') || Array(12).fill(0);
    // this.evaluationPoints = this.evaluation.kps_value.split(',') || Array(12).fill(0);
    // this.P_M_evaluationPoints = this.evaluation.pm_values?.split(',') ;
    this.P_M_evaluationPoints = this.evaluation.pm_values?.split(',') || Array(12).fill(0);

    // this.totalRating = this.evaluationPoints.reduce((partial_sum: any, a: any) => parseInt(partial_sum) + parseInt(a),0);
    this.totalRating1 = this.P_M_evaluationPoints.reduce((partial_sum: any, a: any) => parseInt(partial_sum) + parseInt(a), 0);

    if (this.totalRating1 <= 25) {
      this.band1 = true;
    }
    else if (this.totalRating1 > 25 && this.totalRating1 <= 50) {
      this.band2 = true;
    }
    else if (this.totalRating1 > 50 && this.totalRating1 <= 75) {
      this.band3 = true;
    }
    else {
      this.band4 = true;
    }
    //this.getData(data.month, data.date, data.year);
    //his.getEvalCount(data.month, data.year);
    this.user_detail();

  }
  getCurrentUrl() {


    const url = window.location.href;
    const segments = url.split('/');
    this.currentUrl = segments[segments.length - 1]
  }

  getEvalCount(month: any, year: any) {
    this.showSpinner = true;
    this.evalService
      .getAllEvaluationsCountByMonth(month, year)
      .then((value) => {
        // alert("gere");
        this.lateCheckIn = value.data.LateCheckIn;
        this.taskDelivered = value.data.NotDeliveredTask;
        this.dailyScrum = value.data.missedDailyScrum;
        this.absent = value.data.absent;
        this.asana = value.data.AsanaNotUpdated;
        this.showSpinner = false;
      });

  }

  getEvaluation() {
    // alert("here");
    this.evalService.getEvaluation().then((value) => {
      this.showSpinner = false;
      this.evaluation_later = value.data;
    });
  }

  ngOnInit(): void {
    this.showSpinner = true;
    // this.showSpinner = false;
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }


  getData(month: any, day: any, year: any) {
    // alert("here");
    this.showSpinner = true;
    this.evaluationService
      .getAllEvaluationsDetails(month, day, year)
      .then((value) => {
        // alert('after');
        this.evaluations = value.data.evaluations;
        this.KPValues = value.data.keypoints;
        if (this.KPValues == '') {
          this.check = false;
        }
        this.showSpinner = false;
      });
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
}